import * as React from 'react';
export const IcApple = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.87 7.35a6.55 6.55 0 00-4.88.3V7a4.53 4.53 0 00-2.55-3.89 1.07 1.07 0 00-.39-.11 1.09 1.09 0 00-.4 0 .84.84 0 00-.36.19.82.82 0 00-.29.33.87.87 0 00-.1.39.91.91 0 00.06.4 1 1 0 00.21.35 1 1 0 00.34.23c.403.194.748.49 1 .86.268.368.437.798.49 1.25v.65a6.55 6.55 0 00-4.88-.3C4 8.2 3 10.16 3 13.34c0 3 1.08 5.43 3 6.71a5.69 5.69 0 003.2.95 8.062 8.062 0 002.18-.34c.405-.12.835-.12 1.24 0a8.062 8.062 0 002.18.34 5.701 5.701 0 003.2-1c1.9-1.28 3-3.72 3-6.71 0-2.99-1-5.09-3.13-5.94z'
      fill='currentColor'
    />
  </svg>
);
